<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <!-- 添加 -->
      <div class="MobelBox" v-if="addType">
        <p class="title">{{addType=='add'?'添加会员':'编辑会员'}}</p>
        <form>
          <div class="write-txt">
            <p class="write-title">
              演讲主题<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="addObj.title" style="height:140px;"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              演讲内容<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="addObj.speech_cont" style="height:300px;"></textarea>
            </div>
          </div>
          <div class="write-txt write-input">
            <p class="write-title">
              倒计时设置<span>*</span>
            </p>
            <div class="write-text">
              <input type="number" v-model="addObj.preparation_time">秒
            </div>
          </div>
          <div class="write-txt write-input">
            <p class="write-title">
              演讲时长<span>*</span>
            </p>
            <div class="write-text">
              <div class="write-time">
                <input type="text" v-model="min_minute">分钟
              </div>
              <div class="write-time">
                <input type="text" v-model="min_second">秒
              </div>
              --
              <div class="write-time">
                <input type="text" v-model="max_minute">分钟
              </div>
              <div class="write-time">
                <input type="text" v-model="max_second">秒
              </div>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              语言<span>*</span>
            </p>
            <div class="write-text">
              <el-select v-model="addObj.language" placeholder="请选择">
                <el-option label="中文" value="1"></el-option>
                <el-option label="英文" value="2"></el-option>
              </el-select>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              排序<span>*</span>
            </p>
            <div class="write-text">
              <input type="text" v-model="addObj.sort">
            </div>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="saveSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加读稿</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.speech_cont">
                <span>{{item.speech_cont}}</span>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="修改" @click="reviseShow(item)" class="btn btn-revise"></button>
                <button title="删除" @click="removeShow(item)" class="btn btn-remove"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv" style="height: auto;">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>

import { getReadDraftList, saveReadDraft ,getReadDraftDetail,delReadDraft} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "readIndex",
  data() {
    return {
      navId:'20',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'读稿主题'},
        {id:3,title:'演讲内容'},
        {id:4,title:'添加时间'},
        {id:5,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        language:'1',
        title:'',
        speech_cont:'',
        sort:'',
        preparation_time:'',
        speech_min_time:'',
        speech_max_time:'',
      },
      totalPage:0,
      token:'',
      removeID:'',
      min_minute:'',
      min_second:'',
      max_minute:'',
      max_second:'',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.addObj = {
        language:'1',
        title:'',
        speech_cont:'',
        sort:'',
        preparation_time:'',
        speech_min_time:'',
        speech_max_time:'',
      };
      this.min_minute='';
      this.min_second='';
      this.max_minute='';
      this.max_second='';
      this.dataList = [];
      this.getList();
    },
    
    async getList(){
      var that = this;
      try {
        const response = await getReadDraftList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      this.addType = 'add';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入演讲主题！');
        return false;
      }
      if(this.addObj.speech_cont == ''){
        that.$message('请输入演讲内容！');
        return false;
      }
      if(this.addObj.preparation_time == ''){
        that.$message('请输入倒计时设置！');
        return false;
      }
      if(this.min_minute == '' || this.min_second == ''){
        that.$message('请输入最少时间！');
        return false;
      }
      if(this.max_minute == '' || this.max_second == ''){
        that.$message('请输入最多时间！');
        return false;
      }
      if(this.addObj.sort == ''){
        that.$message('请输入排序！');
        return false;
      }
      this.addObj.speech_min_time = parseInt(parseInt(this.min_minute*60) + parseInt(this.min_second))
      this.addObj.speech_max_time = parseInt(parseInt(this.max_minute*60) + parseInt(this.max_second))
      try {
        const response = await saveReadDraft(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async reviseShow(e){
      var that = this;
      try {
        const response = await getReadDraftDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj = response.data;
          console.log(Math.floor(that.addObj.speech_min_time / 60))
          console.log(Math.floor(that.addObj.speech_min_time / 60))
          that.min_minute = Math.floor(that.addObj.speech_min_time / 60);
          that.min_second = (that.addObj.speech_min_time % 60).toString().padStart(2, '0');
          that.max_minute = Math.floor(that.addObj.speech_max_time / 60);
          that.max_second = (that.addObj.speech_max_time % 60).toString().padStart(2, '0');
          that.addType = 'revise';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },
    
    removeShow(e){
      var that = this;
      this.removeType = true;
      this.removeID = e.id;
    },

    async removeSub(e){
      var that = this;
      try {
        const response = await delReadDraft({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('成功');
          that.removeType = '';
          that.resetSub();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.removeType = false;
      this.addType = '';
      this.addObj = {
        language:'1',
        title:'',
        speech_cont:'',
        sort:'',
        preparation_time:'',
        speech_min_time:'',
        speech_max_time:'',
      };
      this.removeID = '';
      this.vip_date = 'd';
      this.min_minute='';
      this.min_second='';
      this.max_minute='';
      this.max_second='';
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .dataList .listItem p span{
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 20px;
  }

  .MobelBox{
    margin: 20px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
  }

  .MobelBox form{
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    width: 200px;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
    font-size: 18px;
    color: #333333;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox input{
    width: 360px;
    height: 65px;
  }

  .MobelBox input.vip_time{
    display:inline-block;
    width: 120px;
    padding: 0 10px;
    margin-right: 20px;
  }
  
  .MobelBox .write-input .write-text input{
    display: inline-block;
    margin-right: 30px;
  }

  .MobelBox .write-input .write-text .write-time{
    margin: 0 20px;
  }

  .MobelBox .write-input .write-text .write-time input{
    width: 90px;
  }

  .MobelBox .btnBox{
    display: block;
    margin-top: 30px;
    text-align: right;
    margin-right: 40px;
  }

  .MobelBox .btnBox .btn{
    font-size: 20px;
    color: #999999;
    box-sizing: border-box;
    padding: 14px 40px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: top;
    background-color: #F9F9F9;
  }

  .MobelBox .btnBox .btn.btn-sub{
    background-color: #6E2FFF;
    color: #fff;
    margin-right: 40px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .searchBox>>>.search-item input{
    width: 160px;
  }

  .msgBox .contv{
    height: 80%;
  }

  .msgBox .btnBox{
    margin-top: 50px;
  }

  .msgBox>>>.el-radio__label{
    font-size: 15px;
  }
  .msgBox>>>.el-radio-group .el-radio{
    line-height: 30px;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-txt>>> .el-radio__label{
    font-size: 18px;
    vertical-align: top;
  }

  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
    line-height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/read/index.vue